import Button from 'components/Form/Button';
import { FormSeparator } from 'components/Form/Core/styled';
import { CoreContext } from 'context/CoreContext';
import { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Update, UpdateParecer } from 'services/banking';
import { Update as UpdateFP } from 'services/financing-proposals';
import { Title } from 'ui/styled';
import { parseCurrency } from 'utils/parsers';
import FormCore from '../../Form/Core';
import { TimelineContent } from '../BankingNegocios/styled';
import WrapperTwoCol from '../WrapperTwoCol';
import {
  AddProposalContainer,
  ButtonsAndInputWrapper,
  CompanyButtonContainer,
  TimelineContainer,
  TimelineItem,
} from './styled';

export default function CuradoriaBanking({ dados: data, reload }) {
  const { setModal, user } = useContext(CoreContext);
  const formRefBureau = useRef(null);
  const formRefParecer = useRef(null);
  const formRefToExpire = useRef(null);
  const formRefExpired = useRef(null);
  const [showParecer, setShowParecer] = useState(false);
  const [loading, setLoading] = useState(false);

  const close = () => setModal(null);

  const formBureau = [
    {
      ref: 'bureau_score',
      placeholder: 'Score',
      tress: true,
      type: 'number',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'classificacao_julia',
      placeholder: 'Classificação Júlia',
      customWidthCalc: 'calc(100% - 6px) / 1.5',
      type: 'text',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'bacen_vencidos',
      placeholder: 'Total Vencido',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'serasa_restritivos',
      placeholder: 'Valor Negativado',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'bacen_prejuizo',
      placeholder: 'Valor em Prejuízo',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'renda_presumida',
      placeholder: 'Renda Presumida',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'risco_total',
      placeholder: 'Risco Total',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'fatorRiscoSobreRenda',
      placeholder: 'Endividamento',
      tress: true,
      type: 'number',
      disabled: true,
      default: 0,
      transparent: false,
    },
  ];

  const formParecer = [
    {
      ref: 'obs',
      placeholder: 'Observações',
      full: true,
      required: true,
      disabled: false,
    },
  ];

  const formToExpire = [
    {
      ref: 'days_to_expire_30',
      placeholder: 'Até 30 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'days_to_expire_31_60',
      placeholder: '31 a 60 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'days_to_expire_61_90',
      placeholder: '61 a 90 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'days_to_expire_91_180',
      placeholder: '91 a 180 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'days_to_expire_181_360',
      placeholder: '181 a 360 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'more_360_days_to_expire',
      placeholder: 'Mais de 360 dias',
      type: 'text',
      tress: true,
      disabled: true,
      transparent: false,
    },
  ];

  const formExpired = [
    {
      ref: 'expired_15_30',
      placeholder: 'até 30 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'expired_31_60',
      placeholder: '31 a 60 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'expired_61_90',
      placeholder: '61 a 90 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'expired_91_180',
      placeholder: '91 a 180 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'expired_181_360',
      placeholder: '181 a 360 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'more_360_days_expired',
      placeholder: 'Mais de 360 dias',
      tress: true,
      type: 'text',
      disabled: true,
      transparent: false,
    },
  ];

  const negociar = async () => {
    try {
      setLoading(true);
      const form = await formRefParecer.current.getForm?.();
      if (!form) {
        return;
      }
      const newParecer = [
        ...data?.parecer,
        {
          usuario: user.id,
          data: new Date(),
          message: `${form.obs}`,
          origem: 'Curadoria',
        },
      ];
      const payload = {
        status: 'negocio',
        parecer: newParecer,
        data_negocios: new Date(),
      };
      const payloadCuradoria = { curadoria_analise: 'Analisado' };
      const result = await Update({ data: payload }, data.id);
      const resultProp = await UpdateFP(
        { data: payloadCuradoria },
        data.id_proposal
      );
      if (result.status !== 200 && resultProp.status !== 200) {
        throw new Error('Erro ao salvar');
      }
      toast.success('Registro salvo com sucesso!');
      close();
      reload?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  const reprova = async () => {
    try {
      setLoading(true);
      const form = await formRefParecer.current.getForm?.();
      if (!form) {
        return;
      }
      const newParecer = [
        ...data?.parecer,
        {
          usuario: user.id,
          data: new Date(),
          message: `MOTIVO REPROVAÇÃO: ${form.obs}`,
          origem: 'Curadoria',
        },
      ];
      const payload = {
        status: 'recusado',
        parecer: newParecer,
        proposta_financeira: data.id_proposal,
        proposta_bancaria: data.proposta_financeira.propostas_banco[0].id,
      };
      const result = await UpdateParecer({ data: payload }, data.id);
      if (result.status !== 200) {
        throw new Error('Erro ao salvar');
      }
      toast.success('Registro salvo com sucesso!');
      close();
      reload?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // #region == Bureau ==
    formRefBureau.current.setItem(
      data?.crivo_payload?.bureau_score,
      'bureau_score'
    );
    formRefBureau.current.setItem(
      data?.crivo_payload?.client_profile,
      'classificacao_julia'
    );
    formRefBureau.current.setItem(
      data?.crivo_payload?.serasa_restritivos,
      'serasa_restritivos'
    );
    formRefBureau.current.setItem(
      parseCurrency(data?.crivo_payload?.bacen_prejuizo),
      'bacen_prejuizo'
    );
    formRefBureau.current.setItem(
      parseCurrency(data?.crivo_payload?.renda_presumida),
      'renda_presumida'
    );
    formRefBureau.current.setItem(
      data?.crivo_payload?.risco_total,
      'risco_total'
    );
    formRefBureau.current.setItem(
      data?.crivo_payload?.fatorRiscoSobreRenda,
      'fatorRiscoSobreRenda'
    );
    formRefBureau.current.setItem(
      data?.crivo_payload?.bacen_vencidos,
      'bacen_vencidos'
    );
    // #endregion

    // #region == To Expire ==
    formRefToExpire?.current?.setItem(
      parseCurrency(data?.crivo_payload?.days_to_expire_30),
      'days_to_expire_30'
    );
    formRefToExpire?.current?.setItem(
      parseCurrency(data?.crivo_payload?.days_to_expire_31_60),
      'days_to_expire_31_60'
    );
    formRefToExpire?.current?.setItem(
      parseCurrency(data?.crivo_payload?.days_to_expire_61_90),
      'days_to_expire_61_90'
    );
    formRefToExpire?.current?.setItem(
      parseCurrency(data?.crivo_payload?.days_to_expire_91_180),
      'days_to_expire_91_180'
    );
    formRefToExpire?.current?.setItem(
      parseCurrency(data?.crivo_payload?.days_to_expire_181_360),
      'days_to_expire_181_360'
    );
    formRefToExpire?.current?.setItem(
      data?.crivo_payload?.more_360_days_to_expire,
      'more_360_days_to_expire'
    );
    // #endregion

    //#region == Expired ==
    formRefExpired?.current?.setItem(
      data?.crivo_payload?.expired_15_30,
      'expired_15_30'
    );
    formRefExpired?.current?.setItem(
      data?.crivo_payload?.expired_31_60,
      'expired_31_60'
    );
    formRefExpired?.current?.setItem(
      data?.crivo_payload?.expired_61_90,
      'expired_61_90'
    );
    formRefExpired?.current?.setItem(
      data?.crivo_payload?.expired_91_180,
      'expired_91_180'
    );
    formRefExpired?.current?.setItem(
      parseCurrency(data?.crivo_payload?.expired_181_360),
      'expired_181_360'
    );
    formRefExpired?.current?.setItem(
      data?.crivo_payload?.more_360_days_expired,
      'more_360_days_expired'
    );
    formRefBureau.current.setItem(data?.bureau_observacoes, 'obs');
    // #endregion
  }, [data]);
  if (!data) {
    return null;
  }

  return (
    <WrapperTwoCol
      onClose={close}
      title={'Informações'}
      children={
        <AddProposalContainer>
          <TimelineContainer>
            {data?.reprovado.map((rep, idx) => (
              <TimelineItem key={idx}>
                <TimelineContent>
                  <div style={{ marginBottom: '4px' }}>
                    <strong style={{ color: '#2d3748', fontSize: '14px' }}>
                      {rep.regra}
                    </strong>
                  </div>
                  <span
                    style={{
                      fontSize: '15px',
                      color: '#4a5568',
                      lineHeight: '1.4',
                    }}
                  >
                    {rep.detalhe}
                  </span>
                </TimelineContent>
              </TimelineItem>
            ))}
          </TimelineContainer>
        </AddProposalContainer>
      }
      titleColumn1="Motivo(s) da reprovação"
      width="90vw"
      children2={
        <AddProposalContainer>
          <FormCore ref={formRefBureau} formItems={formBureau} />
          <FormSeparator />
          <Title small>A vencer</Title>
          <FormCore ref={formRefToExpire} formItems={formToExpire} />
          <FormSeparator />
          <Title small>Vencido</Title>
          <FormCore ref={formRefExpired} formItems={formExpired} />
        </AddProposalContainer>
      }
      titleColumn2="Bureau"
      footer={
        <div style={{ marginTop: '10px', width: '100%' }}>
          <div
            onClick={() => setShowParecer(!showParecer)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: '#fff',
              padding: '10px',
              borderRadius: '4px',
            }}
          >
            <Title nomargin>Parecer:</Title>
          </div>
          <ButtonsAndInputWrapper>
            <FormCore ref={formRefParecer} formItems={formParecer} />
            <CompanyButtonContainer>
              <Button color="secondary" onClick={reprova} nospace>
                {loading ? 'Processando' : 'Reprovar'}
              </Button>
              <Button onClick={negociar} color="blue" nospace>
                {loading ? 'Processando' : 'Enviar para Negócios'}
              </Button>
            </CompanyButtonContainer>
          </ButtonsAndInputWrapper>
        </div>
      }
    />
  );
}
